import React from "react";

export default function RefundPolicy() {
  return (
    <div className="container mx-auto p-6 max-w-4xl text-gray-800">
      <h1 className="text-3xl font-semibold mb-4">
        Cancellation & Refund Policy
      </h1>
      <p className="mb-4">
        Our Platform provides a secure and reliable cloud-based solution for
        hospital management and human resource operations. Services are
        delivered digitally and accessed through authenticated user accounts.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Free Trial</h2>
      <p className="mb-4">
        All new organizations receive a <strong>90-day free trial</strong>{" "}
        period to evaluate the platform before subscribing. No payment
        information is required during the trial.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        Subscription Cancellations
      </h2>
      <p className="mb-4">
        Subscriptions can be cancelled at any time through the account
        management section or by contacting support at{" "}
        <a href="mailto:admin@cheritto.com" className="text-blue-600 underline">
          admin@cheritto.com
        </a>
        . Cancellation ensures that the next billing cycle is not charged.
        Access remains active until the end of the current paid period.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Refunds</h2>
      <p className="mb-4">
        As services are digitally provisioned, refunds are not provided for
        partial periods, unused time, or mid-cycle cancellations. Refunds will
        only be issued in cases of duplicate or erroneous payments verified by
        our support team.
      </p>
      <p className="mb-4">
        Approved refunds will be processed within{" "}
        <strong>5–7 business days</strong> using the original payment method.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">Contact</h2>
      <p>
        For any queries regarding refunds or cancellations, please contact{" "}
        <a href="mailto:admin@cheritto.com" className="text-blue-600 underline">
          admin@cheritto.com
        </a>
        .
      </p>
    </div>
  );
}
